module.exports = __webpack_public_path__ + "img/icon1s.144d5a9c.png";